// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/tag.js';

import { paths } from '../generated/tag';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('tag', Original, paths);
